import { createSelector } from 'reselect';

export const getInitialData = (state) => state.initialData || {};

export const getRecaptchaV2Key = createSelector(
    getInitialData,
    ({ recaptcha2PublicKey }) => recaptcha2PublicKey,
);

export const getEnv = createSelector(getInitialData, ({ env }) => env);

export const getUser = createSelector(getInitialData, ({ user }) => user);

export const getFeatureFlags = createSelector(
    getInitialData,
    ({ featureFlags }) => featureFlags,
);

export const getHelpLinks = createSelector(
    getInitialData,
    ({ helpLinks }) => helpLinks || {},
);

export const getWhereAreMyTicketsLink = createSelector(
    getHelpLinks,
    ({ whereAreMyTickets }) => whereAreMyTickets,
);

export const getHowToGetARefundLink = createSelector(
    getHelpLinks,
    ({ canIGetARefund }) => canIGetARefund,
);

export const getAttendeeRefundRequirementsLink = createSelector(
    getHelpLinks,
    ({ attendeeRefundRequirements }) => attendeeRefundRequirements,
);
